import {
	SET_CONTRACT, CONTRACT_LIST_RELOAD,
} from "./actionTypes";

export const setContract = data => ({
	type: SET_CONTRACT,
	payload: data
});

export const contractListReload = () => ({
	type: CONTRACT_LIST_RELOAD,
});
